import { render, staticRenderFns } from "./incidents-severities-modal.vue?vue&type=template&id=2b4f974b&"
import script from "./incidents-severities-modal.ts?vue&type=script&lang=ts&"
export * from "./incidents-severities-modal.ts?vue&type=script&lang=ts&"
import style0 from "./incidents-severities-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports